import * as React from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import ReCAPTCHA from "react-google-recaptcha";

import Textfield from "../../Components/Textfield";
import Button from "../../Components/Button";
import Copyright from "../../Components/Copyright";

import { useLoader } from "../../Context/LoaderContext";
import { useToast } from "../../Context/ToastContext";

import Logo from "../../Images/logo.png";
import imgLogin from "../../Images/bg-login.png";

import "./ResetPassword.scss";

const initialFormState = {
  password: "",
  password_confirmation: "",
  token: "",
};

const ResetPassword = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] =
    React.useState(initialFormState);
  const [isVisiblePassword, setIsVisiblePassword] = React.useState(false);
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] =
    React.useState(false);

  const [captchaDone, setIsCaptachDone] = React.useState(false);
    const [tokenRecaptcha, setTokenRecaptcha] = React.useState(null);
  
  const captchaRef = React.useRef(null);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  
    React.useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    const captchaSize = windowWidth > 480 ? "normal" : "compact";

  const { token } = useParams();
  const navigate = useNavigate();
  const { setIsLoading } = useLoader();
  const { addToast } = useToast();

  const handleChangeField = (e, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));
    setValRegister((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/password/reset`, {
        password: valRegister.password,
        password_confirmation: valRegister.password_confirmation,
        token: token,
        grt: tokenRecaptcha
      })
      .then((response) => {
        setIsLoading(false);
        if (response.data.status) {
          navigate("/edited-password");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        captchaRef.current.reset();
        setIsCaptachDone(false);
        if (error?.response?.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const ShowPassword = () => {
    setIsVisiblePassword((prev) => !prev);
  };
  const ShowConfirmPassword = () => {
    setIsVisibleConfirmPassword((prev) => !prev);
  };

  const onChangeCaptcha = (value) => {
    setIsCaptachDone(true);
    setTokenRecaptcha(value)
  };

  return (
    <div className="reset-password-page">
      <div className="wrap-reset-page">
        <div className="content-form">
          <div className="logo">
            <img src={Logo} alt="" />
          </div>
          <h1>Changement mot de passe</h1>
          <p>Veuillez remplir les champs ci dessous</p>

          <form className="register-form" onSubmit={handleSubmit} noValidate>
            <Textfield
              autoComplete="off"
              label="Mot de passe"
              name="password"
              type={isVisiblePassword ? "text" : "password"}
              placeholder="Veuillez insérer votre mot de passe"
              size="large"
              value={valRegister.password}
              onChange={(e) => handleChangeField(e, "password")}
              rightIcon={
                isVisiblePassword ? (
                  <RiEyeLine onClick={ShowPassword} />
                ) : (
                  <RiEyeOffLine onClick={ShowPassword} />
                )
              }
              hasError={formErrorMessages.password}
              errorMessage={
                <div className="text-danger">{formErrorMessages.password}</div>
              }
            />
            <Textfield
              autoComplete="off"
              label="Confirmer mot de passe"
              name="password_confirmation"
              type={isVisibleConfirmPassword ? "text" : "password"}
              placeholder="Veuillez confirmer votre mot de passe"
              size="large"
              value={valRegister.password_confirmation}
              onChange={(e) => handleChangeField(e, "password_confirmation")}
              rightIcon={
                isVisibleConfirmPassword ? (
                  <RiEyeLine onClick={ShowConfirmPassword} />
                ) : (
                  <RiEyeOffLine onClick={ShowConfirmPassword} />
                )
              }
              hasError={formErrorMessages.password_confirmation}
              errorMessage={
                <div className="text-danger">
                  {formErrorMessages.password_confirmation}
                </div>
              }
            />
            <div className="captcha-box">
              <ReCAPTCHA
                key={captchaSize}
                sitekey={process.env.REACT_APP_SITE_KEY}
                ref={captchaRef}
                onChange={onChangeCaptcha}
                size={captchaSize}
              />
            </div>
            <div className="wrap_actions_form">
              <Button
                type="submit"
                variant="warning"
                size="lg"
                disabled={captchaDone ? false : true}
              >
                Modifier
              </Button>
            </div>
          </form>
        </div>
        <div className="img-login">
          <img src={imgLogin} alt="" />
        </div>
      </div>
      <Copyright />
    </div>
  );
};

export default ResetPassword;
